import React, { useEffect, useState } from "react";
import ClientLayout from "../../components/client/ClientLayout";
import RequireClientAdmin from "../../components/client/RequireClientAdmin";
import SyncStatusBanner from "../../components/client/SyncStatusBanner";
import { clientApi } from "../../api";

export default function DemographicsReport() {
  return (
    <ClientLayout>
      <RequireClientAdmin>
        <Inner />
      </RequireClientAdmin>
    </ClientLayout>
  );
}

function Inner() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    clientApi.getDemographics()
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  function downloadCsv(section, rows, keyField) {
    const lines = [[keyField, "count"].join(",")];
    for (const r of rows) {
      const label = r[keyField] == null ? "" : String(r[keyField]).replace(/"/g, '""');
      lines.push(/[",\n]/.test(label) ? `"${label}",${r.count}` : `${label},${r.count}`);
    }
    const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `demographics-${section}.csv`; a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <>
      <div className="venues-page-header">
        <div>
          <h1>Demographic Reports</h1>
          <p className="page-subtitle">Active-member breakdowns by gender, postcode, occupation</p>
        </div>
      </div>

      <SyncStatusBanner cache={data?.cache} />

      {error && <div className="toast toast-error" style={{ marginBottom: "1rem" }}>{error}</div>}
      {loading && <div style={{ color: "var(--text-muted)" }}>Loading…</div>}

      {data && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "1rem" }}>
          <Panel title="By gender"    rows={data.byGender}     keyField="gender"     onCsv={() => downloadCsv("gender", data.byGender, "gender")} />
          <Panel title="By postcode"  rows={data.byPostcode}   keyField="postcode"   onCsv={() => downloadCsv("postcode", data.byPostcode, "postcode")} />
          <Panel title="By occupation" rows={data.byOccupation} keyField="occupation" onCsv={() => downloadCsv("occupation", data.byOccupation, "occupation")} />
        </div>
      )}
    </>
  );
}

function Panel({ title, rows, keyField, onCsv }) {
  const max = Math.max(...(rows || []).map((r) => Number(r.count || 0)), 1);
  return (
    <div className="settings-card">
      <div className="settings-card-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <div>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <p style={{ margin: "0.25rem 0 0", fontSize: "0.8rem" }}>{rows?.length || 0} distinct values</p>
        </div>
        <button className="btn btn-outline btn-sm" onClick={onCsv} disabled={!rows?.length}>CSV</button>
      </div>
      {rows?.length ? rows.map((r, i) => (
        <div key={i} style={{ margin: "0.4rem 0" }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.85rem", marginBottom: "0.2rem" }}>
            <span>{r[keyField] || <span style={{ color: "var(--text-muted)" }}>(blank)</span>}</span>
            <span style={{ fontVariantNumeric: "tabular-nums", color: "var(--text-muted)" }}>{r.count}</span>
          </div>
          <div style={{ height: 4, borderRadius: 999, background: "var(--bg-elevated)" }}>
            <div style={{ height: "100%", width: `${(Number(r.count) / max) * 100}%`, background: "var(--accent)", borderRadius: 999 }} />
          </div>
        </div>
      )) : <div style={{ color: "var(--text-muted)" }}>No data.</div>}
    </div>
  );
}
